import React from 'react';

const Objections = () => {
  const objections = [
    {
      question: 'I\'m worried about referring something that won\'t work.',
      answer: [
        'Hector has 94% customer retention. Brands don\'t leave because of the product, they leave because they scale so fast they outgrow it (and they upgrade instead).',
        'Your reputation is safe. We\'ve earned ours over 4 years of building this. You refer someone once. We keep them happy for years.'
      ]
    },
    {
      question: 'I don\'t have a huge network.',
      answer: [
        'You really don\'t need a huge network. Even a single referral can bring in a solid paid. And with just a few more, you\'re already looking at multiplying that income by 3–5x, enough to create a meaningful financial shift.',
        'Your network is bigger than you think: past clients, colleagues, founders you\'ve consulted, even people who often ask you for advice.',
        'A simple email to 20 people saying "Know anyone struggling with Amazon ads?" is often all it takes to get replies.'
      ]
    },
    {
      question: 'Commission won\'t pay out if they cancel.',
      answer: [
        'Actually, it will. You get paid for the month they use Hector. If they cancel on day 15 of the month, you still earned that commission.',
        'And most don\'t cancel. A 94% retention rate means your affiliate income is more predictable.'
      ]
    },
    {
      question: 'What if Hector raises prices and customers leave?',
      answer: [
        'Price sensitivity isn\'t the reason customers leave Hector. We\'ve raised prices twice, and retention has remained above 93%.',
        'That\'s because ROI > price. Brands are making 5-10x what they pay us. They\'re not leaving over $200/month.'
      ]
    }
  ];

  return (
    <section id="objections" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            Your Top Concerns, <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">Handled Upfront</span>
          </h2>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-6">
          {objections.map((objection, index) => (
            <div key={index} className="objection-card bg-gradient-to-br from-white to-hector-light-grey rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-hector-black mb-4">
                "{objection.question}"
              </h3>
              <div className="space-y-4">
                {objection.answer.map((paragraph, pIndex) => (
                  <p key={pIndex} className={`text-gray-600 leading-relaxed ${pIndex === objection.answer.length - 1 && objection.answer.length > 2 ? 'font-semibold text-hector-purple' : ''}`}>
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
    <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    GET THE SAME LINK OUR AFFILIATES USE
  </button>
</a>

          <p className="text-sm text-gray-600">
            <span className="font-bold text-hector-black">No hidden tiers.</span> Same commission structure. Same tools. Same payouts.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Objections;
